<template>
  <b-modal v-model="displayStatus" :ok-only="true">
    <div slot="modal-title">
      {{ $t('message.promo_code.detail') }}
    </div>
    <div v-if="appliedPromoCode">
      <div class="d-flex justify-content-start align-items-center">
        <div>
          <img :src="(appliedPromoCode.promo_code.image_url) ? appliedPromoCode.promo_code.image_url : '/static/img/logo.png'" alt="" class="rounded-circle" width="40">
        </div>
        <div class="flex-fill pl-3">
          <h4 class="mb-0">{{ appliedPromoCode.promo_code.title }}</h4>
        </div>
      </div>
      <div class="pt-2" v-if="appliedPromoCode.promo_code.province_id || appliedPromoCode.promo_code.service_id">
        <div class="d-inline-block border border-info rounded text-small text-info px-2"
            :class="{'-status-alert border-danger text-danger' : appliedPromoCode.promo_code.disabled}"
            v-if="appliedPromoCode.promo_code.service_id"
            v-html="$options.filters.serviceParentName(appliedPromoCode.promo_code.service_id, globalState.services)"></div>
        <div class="d-inline-block border border-orange rounded text-small text-orange px-2"
            :class="{'-status-alert border-danger text-danger' : appliedPromoCode.promo_code.disabled}"
            v-if="appliedPromoCode.promo_code.province_id">
          {{ globalState.cities[appliedPromoCode.promo_code.province_id] | multiLangName }}
        </div>
      </div>
      <div class="pt-2 pb-2"
          :class="{'-status-offline' : appliedPromoCode.promo_code.disabled}">
        <h3 class="mb-0">
          {{ (appliedPromoCode.promo_code.discount > 0) ? $t('message.promo_code.title', { num: appliedPromoCode.promo_code.discount }) : appliedPromoCode.promo_code.description }}
        </h3>
      </div>
      <div class="pt-1 -status-alert" v-if="!appliedPromoCode.is_applied && appliedPromoCode.status && appliedPromoCode.status === 'not_matched_payment_method'">
        {{ $t('message.promo_code.not_matched_payment_method') }}
      </div>
      <div class="pt-1 text-small"
          :class="{'-status-alert' : appliedPromoCode.promo_code.disabled}"
          v-if="appliedPromoCode.promo_code.discount > 0">
        {{ ($i18n.locale === 'th') ? appliedPromoCode.promo_code.payment_method_th : appliedPromoCode.promo_code.payment_method_en }}
      </div>
      <div class="pt-1 -status-offline text-small">{{ $t('message.promo_code.expiring') }}:
        <span>{{ appliedPromoCode.promo_code.expire_date | prettyOnlyDate }}</span>
      </div>
    </div>
  </b-modal>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    data () {
      return {
        displayStatus: false,
        promoCode: null
      }
    },
    computed: {
      ...mapGetters({
        globalState: 'globalVal/getState',
        appliedPromoCode: 'promoCode/getAppliedPromoCode',
        user: 'auth/getUser'
      })
    },
    methods: {
      showModal (status) {
        this.displayStatus = status
      }
    },
    mounted () {
      if (this.appliedPromoCode) {
        this.promoCode = this.appliedPromoCode.promo_code
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/booking/components/PromoCodeDetailModal.vue